var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"#e1e2fa","padding-left":"10px","padding-right":"10px","height":"50px","border-radius":"5px"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }